export const createMarkup = (text: string): { __html: string } => {
  return { __html: text };
};
